import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import DataUtil from "../../../actions/data";

import CadastroObservacao from "./CadastroObservacao";
import CadastroPaciente from "./CadastroPaciente";

class CadastroAtendimento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarioId: this.props.usuario.id,
      atendimento: this.getInitialState(),
      usuarios: [],
      procedimentos: [],
    };
    if (this.props.match.params.id) {
      this.state.atendimento.id = this.props.match.params.id;
    }

    this.getInitialState = this.getInitialState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAtendimento = this.handleChangeAtendimento.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.adicionarValor = this.adicionarValor.bind(this);
    this.removerValor = this.removerValor.bind(this);
    this.alterarPaciente = this.alterarPaciente.bind(this);
  }

  getInitialState() {
    return {
      id: 0,
      usuarioId: 0,
      procedimentoId: 0,
      pacienteId: 0,
      data: DataUtil.hoje(),
      horaEntrada: "00:00",
      horaSaida: "00:00",
      descricao: "",
      estado: "PR",
      cidade: "LONDRINA",
      unidade: 1,
      valorReceber: "0.00",
      dataPagamento: "",
      observacoes: "",
      tipo: 1,
      paciente: false,
      quantidade: 1, // teste
      valores: [],
    };
  }

  // Hack para atualizar a pagina quando estiver nessa rota
  componentWillReceiveProps() {
    window.scrollTo(0, 0);
    let initial = this.getInitialState();
    initial.procedimentoId =
      this.state.procedimentos.length > 0 ? this.state.procedimentos[0].id : 0;
    initial.unidade =
      this.state.procedimentos.length > 0
        ? this.state.procedimentos[0].unidade
        : 1;
    this.setState({ atendimento: initial });
  }

  componentDidMount() {
    UI.loader("show", "Um momento...");
    API.get("/usuarios/ativos").then(
      function (json) {
        // Cria uma lista simplificada de usuários à vincular ...
        let usuarios = json.data;
        let state = this.state;
        //state.usuarioId = usuarios[0].id;

        API.get("/procedimentos/atendimento").then(
          function (json) {
            // Cria uma lista simplificada de atividades à vincular ...
            let procedimentos = json.data;
            let atendimento = state.atendimento;
            atendimento.procedimentoId =
              procedimentos.length > 0 ? procedimentos[0].id : 0;
            atendimento.unidade =
              procedimentos.length > 0 ? procedimentos[0].unidade : 1;

            // Se não houver procedimentos cadastrados não é possível continuar
            if (procedimentos.length === 0) {
              UI.alert(
                false,
                "Não há nenhum procedimento cadastrado, verifique."
              );
              UI.loader("hide");
              return;
            }

            this.setState({
              atendimento: atendimento,
              usuarios: usuarios,
              procedimentos: procedimentos,
            });

            // Selecionar automaticamente o profissional
            let id = parseInt(this.state.atendimento.id);
            if (id === 0) {
              this.adicionarValor();
            }

            // Carrega o atendimento selecionado para edição
            id = parseInt(this.state.atendimento.id);
            if (id !== 0) {
              UI.loader("show", "Um momento...");
              API.get("/atendimentos/" + id)
                .then(
                  function (json) {
                    if (!json.data.dataPagamento) json.data.dataPagamento = "";
                    if (!json.data.paciente.dataNascimento)
                      json.data.paciente.dataNascimento = "";
                    this.setState({ atendimento: json.data });
                    UI.loader("hide");
                  }.bind(this)
                )
                .catch(function (json) {
                  UI.alert(false, json.message);
                  UI.loader("hide");
                });
            } else {
              UI.loader("hide");
            }
          }.bind(this)
        );
      }.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    let data = this.state.atendimento;

    // Jackson não deserializa horário sem segundos
    data.horaEntrada = data.horaEntrada.substr(0, 5) + ":00";
    data.horaSaida = data.horaSaida.substr(0, 5) + ":00";

    if (!DataUtil.validarData(data.dataPagamento)) data.dataPagamento = "";

    if (data.valores.length === 0) {
      UI.alert(false, "Os profissionais não foram selecionados.");
      return;
    }
    // else if (data.pacienteId === 0) {
    //   UI.alert(false, "O paciente não foi selecionado.");
    //   return;
    // }
    else if (data.descricao.length <= 3) {
      UI.alert(false, "Informe uma descrição para o atendimento.");
      return;
    } else if (!DataUtil.validarHora(data.horaEntrada)) {
      UI.alert(
        false,
        "Preencha corretamente a hora de entrada do atendimento."
      );
      return;
    } else if (!DataUtil.validarHora(data.horaSaida)) {
      UI.alert(false, "Preencha corretamente a hora de saída do atendimento.");
      return;
    }

    // Chamada da API
    UI.loader("show", "Um momento...");
    API.post("/atendimentos", data)
      .then(
        function (json) {
          if (json.success) {
            this.setState({ atendimento: json.data });
          }
          UI.alert(json.success, json.message);
          UI.loader("hide");

          // Zerar valores para incluir novo paciente
          let procedimento = false;
          let index = this.state.procedimentos.findIndex(
            (value, index, obj) => {
              return (
                parseInt(value.id) ===
                parseInt(this.state.atendimento.procedimentoId)
              );
            }
          );
          if (index >= 0) {
            procedimento = this.state.procedimentos[index];
          }
          if (procedimento.grupoPaciente) {
            UI.confirm(
              "Pronto",
              "Deseja cadastrar mais um paciente neste horário?",
              "Não",
              "SIm"
            ).then((value) => {
              if (!value) {
                UI.alert(json.success, json.message);
                return;
              }

              // Zerar os campos que não se repetem
              let atendimento = this.state.atendimento;
              atendimento.id = 0;
              atendimento.pacienteId = 0;
              atendimento.paciente = false;
              atendimento.valores.map(function (valor) {
                valor.id = 0;
                return true;
              });
              this.setState({ atendimento: atendimento });

              // Focar o campo do paciente
              var form = document.forms[0];
              var idCismepar = form.querySelector('input[name="idCismepar"]');
              idCismepar.focus();
            });
          }
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  adicionarValor() {
    let index = this.state.atendimento.valores.findIndex(
      (value, index, obj) => {
        return parseInt(value.usuarioId) === parseInt(this.state.usuarioId);
      }
    );
    if (index >= 0) {
      UI.alert(
        false,
        "O profissional que você quer incluir já esta na lista de participantes deste atendimento."
      );
      return;
    }

    index = this.state.procedimentos.findIndex((value, index, obj) => {
      return (
        parseInt(value.id) === parseInt(this.state.atendimento.procedimentoId)
      );
    });
    if (index >= 0) {
      let procedimento = this.state.procedimentos[index];
      index = procedimento.valores.findIndex((value, index, obj) => {
        return parseInt(value.usuarioId) === parseInt(this.state.usuarioId);
      });
      if (index >= 0) {
        let valor = procedimento.valores[index];
        let valorAdd = {
          usuarioId: valor.usuarioId,
          usuarioNome: valor.usuarioNome,
          unidade: valor.unidade,
          valorPagar: valor.valorPagar,
        };
        let atendimento = this.state.atendimento;
        atendimento.valorReceber = procedimento.valorReceber;
        atendimento.valores.push(valorAdd);
        this.setState({ atendimento: atendimento });
        return;
      }
    }
    UI.alert(
      false,
      "O profissional selecionado não pode participar deste tipo de procedimento."
    );
  }

  removerValor(usuarioId) {
    let atendimento = this.state.atendimento;
    atendimento.valores = atendimento.valores.filter((value, index, obj) => {
      return usuarioId !== value.usuarioId;
    });
    this.setState({ atendimento: atendimento });
  }

  alterarPaciente(paciente) {
    let atendimento = this.state.atendimento;
    atendimento.pacienteId = paciente.id;
    atendimento.paciente = paciente;
    this.setState({ atendimento: atendimento });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangeAtendimento(event) {
    let atendimento = this.state.atendimento;
    atendimento[event.target.name] = event.target.value;
    if (event.target.name === "procedimentoId") {
      let proc = this.state.procedimentos.find((val) => {
        return parseInt(atendimento.procedimentoId) === val.id;
      });
      atendimento.unidade = proc ? proc.unidade : 1;
      atendimento.valores = [];
      atendimento.valorReceber = "0.00";
    }
    this.setState({ atendimento: atendimento });
  }

  render() {
    if (this.state.procedimentos.length === 0) {
      return false;
    }

    let procedimento = null;
    let classeQuantidade = "col-md-12";
    let index = this.state.procedimentos.findIndex((value) => {
      return (
        parseInt(value.id) === parseInt(this.state.atendimento.procedimentoId)
      );
    });
    if (this.state.atendimento.id === 0 && index >= 0) {
      procedimento = this.state.procedimentos[index];
      classeQuantidade = this.state.procedimentos[index].usaQuantidade
        ? "col-md-11"
        : "col-md-12";
    }

    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    {this.state.atendimento.id === 0 && (
                      <h4 className="card-title">NOVO ATENDIMENTO</h4>
                    )}
                    {this.state.atendimento.id !== 0 && (
                      <h4 className="card-title">
                        CADASTRO ATENDIMENTO #{this.state.atendimento.id}
                      </h4>
                    )}
                  </div>
                  {this.state.atendimento.id !== 0 && (
                    <div className="col-md-6 text-right">
                      <button
                        onClick={() => {
                          this.props.history.push(
                            "/atendimento/auditoria/" +
                              this.state.atendimento.id
                          );
                        }}
                        className="btn btn-info"
                      >
                        <i className="fa fa-clock-o"></i>&nbsp;Auditoria
                      </button>
                    </div>
                  )}
                </div>
                <div className="form-group row">
                  <div className={classeQuantidade}>
                    <label>Cód / Procedimento *</label>
                    <select
                      name="procedimentoId"
                      className="form-control"
                      value={this.state.atendimento.procedimentoId}
                      onChange={this.handleChangeAtendimento}
                    >
                      {this.state.procedimentos.map(function (procedimento, i) {
                        return (
                          <option key={procedimento.id} value={procedimento.id}>
                            {procedimento.codigo +
                              " - " +
                              procedimento.descricao}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {this.state.atendimento.id === 0 &&
                    procedimento.usaQuantidade && (
                      <div className="col-md-1">
                        <label>Quantidade</label>
                        <select
                          name="quantidade"
                          className="form-control"
                          value={this.state.atendimento.quantidade}
                          onChange={this.handleChangeAtendimento}
                        >
                          <option value={1}>1</option>
                          <option value={2}>2</option>
                          <option value={3}>3</option>
                          <option value={4}>4</option>
                          <option value={5}>5</option>
                          <option value={6}>6</option>
                          <option value={7}>7</option>
                          <option value={8}>8</option>
                          <option value={9}>9</option>
                        </select>
                      </div>
                    )}
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Profissionais Disponíveis</label>
                    <div className="input-group">
                      <select
                        name="usuarioId"
                        className="form-control"
                        value={this.state.usuarioId}
                        onChange={this.handleChange}
                      >
                        {this.state.usuarios.map(function (usuario, i) {
                          return (
                            <option key={usuario.id} value={usuario.id}>
                              {usuario.nome}
                            </option>
                          );
                        })}
                      </select>
                      <div className="input-group-append">
                        <button
                          className="btn btn-xs btn-primary"
                          type="button"
                          onClick={this.adicionarValor}
                        >
                          Incluir
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <label>
                      Participantes *{" "}
                      <i className="light-description">(clique para remover)</i>
                    </label>
                    <div className="badge-background">
                      {this.state.atendimento.valores.length === 0 && (
                        <div className="badge badge-none">
                          Nenhum profissional foi selecionado...
                        </div>
                      )}
                      {this.state.atendimento.valores.map((valor) => {
                        return (
                          <div
                            key={valor.usuarioId}
                            onClick={() => {
                              this.removerValor(valor.usuarioId);
                            }}
                            className="badge badge-warning badge-remove"
                          >
                            <i className="icon icon-user"></i>&nbsp;
                            {valor.usuarioNome}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Data *</label>
                    <InputMask
                      placeholder="DATA"
                      name="data"
                      className="form-control"
                      mask="99/99/9999"
                      value={this.state.atendimento.data}
                      onChange={this.handleChangeAtendimento}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Hora Entrada *</label>
                    <InputMask
                      placeholder="HORA INICIO"
                      name="horaEntrada"
                      className="form-control"
                      mask="99:99"
                      value={this.state.atendimento.horaEntrada}
                      onChange={this.handleChangeAtendimento}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Hora Saída *</label>
                    <InputMask
                      placeholder="HORA FIM"
                      name="horaSaida"
                      className="form-control"
                      mask="99:99"
                      value={this.state.atendimento.horaSaida}
                      onChange={this.handleChangeAtendimento}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Atendimento</label>
                    <select
                      name="tipo"
                      className="form-control"
                      value={this.state.atendimento.tipo}
                      onChange={this.handleChangeAtendimento}
                    >
                      <option value={1}>PRIMEIRA CONSULTA</option>
                      <option value={2}>RETORNO</option>
                      <option value={3}>CANCELADO</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Descrição *</label>
                    <input
                      placeholder="DESCRICAO"
                      name="descricao"
                      className="form-control"
                      value={this.state.atendimento.descricao}
                      onChange={this.handleChangeAtendimento}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Estado (Atendimento)</label>
                    <input
                      readOnly
                      placeholder="ESTADO"
                      name="estado"
                      className="form-control"
                      value={this.state.atendimento.estado}
                      onChange={this.handleChangeAtendimento}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Cidade (Atendimento)</label>
                    <select
                      name="cidade"
                      className="form-control"
                      value={this.state.atendimento.cidade}
                      onChange={this.handleChangeAtendimento}
                    >
                      <option value={"ALVORADA DO SUL"}>ALVORADA DO SUL</option>
                      <option value={"ASSAI"}>ASSAI</option>
                      <option value={"BELA VISTA DO PARAISO"}>
                        BELA VISTA DO PARAISO
                      </option>
                      <option value={"CAFEARA"}>CAFEARA</option>
                      <option value={"CAMBE"}>CAMBE</option>
                      <option value={"CENTENÁRIO DO SUL"}>
                        CENTENÁRIO DO SUL
                      </option>
                      <option value={"FLORESTOPOLIS"}>FLORESTOPOLIS</option>
                      <option value={"GUARACI"}>GUARACI</option>
                      <option value={"IBIPORA"}>IBIPORA</option>
                      <option value={"JAGUAPITA"}>JAGUAPITA</option>
                      <option value={"JATAIZINHO"}>JATAIZINHO</option>
                      <option value={"LONDRINA"}>LONDRINA</option>
                      <option value={"LUPIONOPOLIS"}>LUPIONOPOLIS</option>
                      <option value={"MIRASELVA"}>MIRASELVA</option>
                      <option value={"PITANGUEIRAS"}>PITANGUEIRAS</option>
                      <option value={"PORECATU"}>PORECATU</option>
                      <option value={"PRADO FERREIRA"}>PRADO FERREIRA</option>
                      <option value={"PRIMEIRO DE MAIO"}>
                        PRIMEIRO DE MAIO
                      </option>
                      <option value={"ROLANDIA"}>ROLANDIA</option>
                      <option value={"SERTANOPOLIS"}>SERTANOPOLIS</option>
                      <option value={"TAMARANA"}>TAMARANA</option>
                    </select>
                  </div>
                  {this.props.usuario.perfil < 2 && false && (
                    <div className="col-md-3">
                      <label>Data Pagamento</label>
                      <div className="input-group">
                        <InputMask
                          placeholder="DATA PAGAMENTO"
                          name="dataPagamento"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.atendimento.dataPagamento}
                          onChange={this.handleChangeAtendimento}
                        />
                        <div className="input-group-append">
                          {DataUtil.validarData(
                            this.state.atendimento.dataPagamento
                          ) && (
                            <button
                              className="btn btn-xs btn-success"
                              type="button"
                              onClick={this.definirPagamento}
                            >
                              Recebido
                            </button>
                          )}
                          {!DataUtil.validarData(
                            this.state.atendimento.dataPagamento
                          ) && (
                            <button
                              className="btn btn-xs btn-danger"
                              type="button"
                              onClick={this.definirPagamento}
                            >
                              Pendente
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CadastroPaciente
          paciente={this.state.atendimento.paciente}
          onChange={this.alterarPaciente}
        />
        <CadastroObservacao
          observacoes={this.state.atendimento.observacoes}
          onChange={this.handleChangeAtendimento}
        />
      </form>
    );
  }
}

export default withRouter(CadastroAtendimento);
